import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  template: `
    <div *ngIf="isVisible" class="rtl z-120 overflow-y-auto overflow-x-hidden flex fixed top-0 right-0 left-0 justify-center items-center w-full md:inset-0 h-full max-h-full">
        <div class="relative z-100 w-auto my-auto mx-auto max-w-4xl min-w-full">
        <div class="bg-white rounded-lg shadow relative p-4 w-full">
            <button (click)="close()" class="absolute top-3 right-3 text-gray-400 hover:text-gray-900 dark:hover:text-white">
                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                </svg>
                <span class="sr-only">Close modal</span>
            </button>
            <div class="md:p-5 text-center">
                <ng-content></ng-content>
            </div>
        </div>
    </div>

    <div *ngIf="isVisible" class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full top-0 right-0"></div>
    
  `
})
export class ModalComponent {
  isVisible = false;

  @Output() closed = new EventEmitter<void>();

  open() {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
    this.closed.emit();
  }
}







// <div *ngIf="isVisible" class="overflow-y-auto overflow-x-hidden flex fixed top-0 right-0 left-0 z-100 justify-center items-center w-full md:inset-0 h-full max-h-full">
//         <div class="relative w-auto my-auto mx-auto max-w-4xl">
//           <!--content-->
//           <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
//             <!--header-->
//             <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
//               <h3 class="text-3xl font-semibold">
//                 Modal Title
//               </h3>
//               <button class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" (click)="close()">
//                 <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
//                   ×
//                 </span>
//               </button>
//             </div>
//             <!--body-->
//             <div class="relative p-6 flex-auto">
//               <p class="my-4 text-blueGray-500 text-lg leading-relaxed">
//                 I always felt like I could do anything. That’s the main
//                 thing people are controlled by! Thoughts- their perception
//                 of themselves! They're slowed down by their perception of
//                 themselves. If you're taught you can’t do anything, you
//                 won’t do anything. I was taught I could do everything.
//               </p>
//             </div>
//             <!--footer-->
//             <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
//               <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" (click)="close()">
//                 Close
//               </button>
//               <button class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div *ngIf="isVisible" class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full top-0 right-0"></div>